import React, { useRef } from 'react';
import { Printer } from 'lucide-react';
interface BillReceiptProps {
  billNo: string;
  gatePassNo: string;
  vehicleNo: string;
  amount: number;
  paymentMode: string;
  dateTime: string;
  onClose: () => void;
}
export function BillReceipt({
  billNo,
  gatePassNo,
  vehicleNo,
  amount,
  paymentMode,
  dateTime,
  onClose
}: BillReceiptProps) {
  const receiptRef = useRef<HTMLDivElement>(null);
  const handlePrint = () => {
    document.body.classList.add('print-thermal');
    window.print();
    document.body.classList.remove('print-thermal');
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 print:bg-white print:p-0" data-id="element-17">
      {/* Action buttons - hidden on print */}
      <div className="absolute top-4 right-4 flex gap-2 print:hidden" data-id="element-18">
        <button onClick={handlePrint} className="flex items-center gap-2 bg-brand-teal text-white px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-brand-tealHover transition-colors min-h-[48px]" data-id="element-19">
          <Printer className="w-4 h-4" data-id="element-20" />
          Print
        </button>
        <button onClick={onClose} className="bg-white text-slate-700 px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-slate-100 transition-colors min-h-[48px] border border-slate-200" data-id="element-21">
          Close
        </button>
      </div>

      {/* Receipt */}
      <div ref={receiptRef} id="print-receipt" className="bg-white w-[302px] font-mono text-[11px] leading-[1.4] text-black p-4 shadow-2xl print:shadow-none print:w-[80mm] print:p-[4mm]" data-id="element-22">
        {/* Company Header */}
        <div className="text-center mb-1" data-id="element-23">
          <div className="text-[15px] font-bold tracking-wide" data-id="element-24">ERPLogiPark</div>
          <div className="text-[9px] leading-tight mt-0.5 text-gray-700" data-id="element-25">
            Terminal Management &amp; Gate Automation
          </div>
        </div>

        {/* Address */}
        <div className="text-center text-[9px] leading-tight text-gray-600 mb-2" data-id="element-26">
          Plot No. 45, Logistics Hub, Sector 18
          <br data-id="element-27" />
          Industrial Area, Bangalore - 560100
          <br data-id="element-28" />
          GSTIN: 29ABCDE1234F1Z5
        </div>

        {/* Separator */}
        <div className="border-t border-dashed border-gray-400 my-2" data-id="element-29" />

        {/* Title */}
        <div className="text-center font-bold text-[13px] tracking-wider mb-1" data-id="element-30">
          TAX INVOICE / RECEIPT
        </div>

        {/* Separator */}
        <div className="border-t border-dashed border-gray-400 my-2" data-id="element-31" />

        {/* Details */}
        <div className="space-y-[6px]" data-id="element-32">
          <div className="flex justify-between" data-id="element-33">
            <span className="text-gray-500" data-id="element-34">Bill No:</span>
            <span className="font-bold" data-id="element-35">{billNo}</span>
          </div>
          <div className="flex justify-between" data-id="element-36">
            <span className="text-gray-500" data-id="element-37">Date/Time:</span>
            <span data-id="element-38">{dateTime}</span>
          </div>

          <div className="border-t border-dotted border-gray-300 my-1" data-id="element-39" />

          <div className="flex justify-between" data-id="element-40">
            <span className="text-gray-500" data-id="element-41">GP No:</span>
            <span data-id="element-42">{gatePassNo}</span>
          </div>
          <div className="flex justify-between" data-id="element-43">
            <span className="text-gray-500" data-id="element-44">Vehicle No:</span>
            <span className="font-bold text-[12px]" data-id="element-45">{vehicleNo}</span>
          </div>

          <div className="border-t border-dotted border-gray-300 my-1" data-id="element-46" />

          <div className="flex justify-between font-bold text-[13px] mt-2 mb-1" data-id="element-47">
            <span data-id="element-48">TOTAL AMOUNT:</span>
            <span data-id="element-49">₹{amount.toFixed(2)}</span>
          </div>

          <div className="flex justify-between text-[10px]" data-id="element-50">
            <span className="text-gray-500" data-id="element-51">Payment Mode:</span>
            <span data-id="element-52">{paymentMode}</span>
          </div>
        </div>

        {/* Separator */}
        <div className="border-t border-dashed border-gray-400 my-3" data-id="element-53" />

        {/* Footer */}
        <div className="text-center text-[8px] text-gray-500 leading-tight" data-id="element-54">
          <div data-id="element-55">Thank you for your business!</div>
          <div data-id="element-56">This is a computer generated invoice.</div>
          <div className="mt-1" data-id="element-57">© 2026 ERPLogiPark</div>
        </div>
      </div>
    </div>;
}